import { render, staticRenderFns } from "./OldBrowserInformation.vue?vue&type=template&id=3c9f4c68&"
import script from "./OldBrowserInformation.vue?vue&type=script&lang=js&"
export * from "./OldBrowserInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../DM.Umbraco.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports